export default __webpack_public_path__ + "static/media/icon_bandtype_Eternity.bfea15d9.png";